import React from 'react';
import { getDescText, getPublishDate } from '../../common/services/builders';
import PropTypes from 'prop-types';

function SearchItem({ entry, settings} ) {

    var searchPageUri = settings.baseUri;

    let date = entry.eventDate ? entry.eventDate.from : entry.publishDate;
	let entryDate = new Date(date);


    switch (entry.sys.contentTypeId) {
        case 'pressReleases':
            searchPageUri = settings.pressReleasesBaseUri + '/' + entryDate.getFullYear() + '/' + entry.sys.slug;
            break;
        case 'events':
            searchPageUri = settings.eventsBaseUri + '/' + entry.sys.slug;
            break;
        case 'insights':
            searchPageUri = settings.insightsBaseUri + '/' + entry.sys.slug;
            break;
        default:
            searchPageUri = entry.sys.uri;
        break;
      } 

    return (
        <div className="search-result">
            <div className="row">
                <div className="small-6 column">
                    {renderTypeTag(entry)}
                </div>
            </div>
            <div className="row column">
                <h4><a href={searchPageUri}>{entry.title}</a></h4>
                <span dangerouslySetInnerHTML={{__html: getDescText(entry)}}></span>
                <span className="date">
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-clock"></use>
                    </svg>
                    {getPublishDate(entry)}
                </span>
            </div>
        </div>
    );
    
}

function renderTypeTag(entry){
    if(entry.sys.dataFormat == 'webpage'){
        return <span className="category--tag">Webpage</span>;
    } 
    else if (entry.sys.contentTypeId == 'insights')
    {
        return <span className="category--tag">Case Studies</span>;
    }
    else{
        return <span className="category--tag">{entry.sys.contentTypeId.split(/(?=[A-Z])/).join(" ")}</span>;
    }
}


SearchItem.propTypes = {
    entry: PropTypes.object,
    settings: PropTypes.object
};


export default SearchItem;